import React from "react";
// this comment for disable the 'Router' is defined but never used
// eslint-disable-next-line
import { Routes, Route } from "react-router-dom";
import { paths } from "../constants/paths/common";
import StudentConsentPage from "../pages/Student/StudentConsentPage/StudentConsentPage";

export default function AppRoutes() {
  return (

    < Routes>
      <Route path={paths.HOME} element={<StudentConsentPage />}></Route>
    </Routes>
  );
}
